import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.304 13.86a.66.66 0 0 1-.292-.438.61.61 0 0 1 .142-.494L9.353 8 5.154 3.072a.61.61 0 0 1-.142-.494.66.66 0 0 1 .292-.438.8.8 0 0 1 .267-.118.84.84 0 0 1 .578.073q.13.069.22.178l4.438 5.208a.8.8 0 0 1 .197.519c0 .188-.069.37-.197.52L6.37 13.726a.7.7 0 0 1-.22.178.81.81 0 0 1-.578.073.8.8 0 0 1-.267-.118",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }